"use client";

import { useLayoutEffect, type ReactNode } from "react";
import { useFontOption } from "@/hooks/use-font-option";
import {
  DEFAULT_FONT_OPTION,
  FONT_OPTION_BOOTSTRAP_SCRIPT,
  applyFontOptionToDocument,
} from "@/lib/font-option";

export function FontOptionProvider({ children }: { children: ReactNode }) {
  const [fontOption] = useFontOption();
  useLayoutEffect(() => {
    applyFontOptionToDocument(fontOption);
  }, [fontOption]);
  useLayoutEffect(() => {
    return () => applyFontOptionToDocument(DEFAULT_FONT_OPTION);
  }, []);

  return (
    <>
      <script
        dangerouslySetInnerHTML={{ __html: FONT_OPTION_BOOTSTRAP_SCRIPT }}
        id="ds-font-option"
      />
      {children}
    </>
  );
}
